module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"welcome":"Добро пожаловать!","info":"Для заполнения педагогической нагрузки, пожалуйста, выберите слева учебный год."},"kz":{"welcome":"Қош келдіңіз!","info":"Оқу жүктемесін толтыру үшін сол жақтағы оқу жылын таңдаңыз."}}')
  delete Component.options._Ctor
}
